export interface GuestData {
  coverageEffectiveDate?: string;
  coverageType?: string;
  exchangeId?: string;
  gated?: string;
  language?: string;
  lob?: string;
  ndbLob?: string;
  planId?: string;
  portalSource?: string;
  qhpId?: string;
  stateCode?: string;
  virtualFirst?: string;
  zipCode?: string;
}

export interface GuestPlanSelectorData {
  clusterKey?: string;
  coverageType?: string;
  customBranding?: string;
  delsysCode?: string;
  fipsCode?: string;
  isGuestDeeplinkFlow?: boolean;
  isYearFirstFlow?: boolean;
  planId?: string;
  planName?: string;
  planYear?: string;
  policyNumber?: string;
  portal?: string;
  pvrcode?: string;
  // Set once when a deeplink flow first lands without a coverageType, so the
  // "Type of Care" breadcrumb keeps showing even after coverageType is later selected.
  requiresTypeOfCareSelection?: boolean;
  saveWithoutPlanValidation?: boolean;
  search?: string;
  signIn?: string;
  source?: string;
  stateCode?: string;
}

export interface GuestState {
  guestData: GuestData;
  setGuestData: (values: GuestData) => void;
  clearGuestData: (defaultValues?: GuestData) => void;
  guestPlanSelectorData: GuestPlanSelectorData;
  setGuestPlanSelectorData: (values: GuestPlanSelectorData) => void;
  clearGuestPlanSelectorData: (defaultValues?: GuestPlanSelectorData) => void;
  chooseType: string;
  setChooseType: (chooseType: string) => void;
}

export enum StoreKeys {
  GUEST_DATA = 'guestData',
  SET_GUEST_DATA = 'setGuestData',
  CLEAR_GUEST_DATA = 'clearGuestData',
  GUEST_PLAN_SELECTOR_DATA = 'guestPlanSelectorData',
  SET_GUEST_PLAN_SELECTOR_DATA = 'setGuestPlanSelectorData',
  CLEAR_GUEST_PLAN_SELECTOR_DATA = 'clearGuestPlanSelectorData',
  CHOOSE_TYPE = 'chooseType',
  SET_CHOOSE_TYPE = 'setChooseType',
}

export const initialState = {
  [StoreKeys.GUEST_DATA]: {},
  [StoreKeys.GUEST_PLAN_SELECTOR_DATA]: {},
  [StoreKeys.CHOOSE_TYPE]: '',
};

export const PERSIST_KEYS = [
  StoreKeys.GUEST_DATA,
  StoreKeys.GUEST_PLAN_SELECTOR_DATA,
];
